import { render, staticRenderFns } from "./PerformanceReviewItem.vue?vue&type=template&id=e5b85d24&scoped=true&"
import script from "./PerformanceReviewItem.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReviewItem.vue?vue&type=style&index=0&id=e5b85d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b85d24",
  null
  
)

export default component.exports